
import { ExtendedWindow } from '@/models/app.model';
import Vue from 'vue';

export default Vue.extend({
    name: 'Loader',
    data() {
        return {
            loaderElement: document.querySelector('#appLoader') as HTMLDivElement,
            loaderProgressValue: document.querySelector('#appLoader .progress__value') as HTMLSpanElement,
        };
    },
    props: {
        hide: {
            type: Boolean,
            default: false,
        },
        progress: {
            type: Number,
            default: 0,
        },
    },
    watch: {
        hide() {
            if (this.hide) {
                this.hideLoader();
                clearInterval((window as unknown as ExtendedWindow).progressDotsInterval);
            } else {
                this.showLoader();
            }
        },
        progress(v) {
            if (this.loaderProgressValue) {
                if (v === 100) this.loaderProgressValue.innerText = '99%';
                else this.loaderProgressValue.innerText = `${v}%`;
            }
        },
    },
    methods: {
        hideLoader() {
            this.loaderElement.style.display = 'none';
        },
        showLoader() {
            this.loaderElement.style.display = 'flex';
        },
    },
});
